<div #editingBoxWrapper id="editingBoxWrapper">
  <!--
      ASSOCIATED, DISPLAY ONLY THE FIRST COLUMN LABEL
      NORMAL, DISPLAYS LABEL FOR EACH COLUMN
    -->
  <div class="filters associated">
    <ng-container *ngFor="let column of reportSection; index as colIndex">
      <div
        *ngIf="
          !column.field.includes('property_apn_number') && !column.field.includes('target_geography.city/city_desc');
          else arrayAssociated
        "
      >
        <div class="user-filter-label">
          <label class="filter-label"> {{ column.header }}</label>
        </div>
        <miq-uom-record-detail-inputs
          *ngIf="column.unit; else singleField"
          [recordDetail]="column"
          [record]="record"
          [module]="'reports'"
          (rdChange)="onUomChange($event)"
        >
        </miq-uom-record-detail-inputs>
        <ng-template #singleField>
          <miq-editing-box-field
            [record]="record"
            [column]="column"
            (modified)="onChange($event)"
          ></miq-editing-box-field>
        </ng-template>
      </div>
      <ng-template #arrayAssociated>
        <miq-editing-box-arrays
          [record]="record"
          [column]="column"
          (removeItem)="onArrayItemRemove($event)"
          (modified)="onArrayItemAdd($event)"
        >
        </miq-editing-box-arrays>
      </ng-template>
    </ng-container>
  </div>
  <ng-template #array>
    <miq-editing-box-arrays
      [record]="record"
      [column]="column"
      (modified)="onArrayItemAdd($event)"
      (removeItem)="onArrayItemRemove($event)"
    >
    </miq-editing-box-arrays>
  </ng-template>
</div>
